import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const pvgisUrl = (environment.pvgisUrl ?? '').trim().replace(/\s+/g, '');
  const pvgisApiBase = resolvePvgisApiBase(pvgisUrl);
  const isPvgisRequest =
    isMatchingUrl(req.url, pvgisUrl) ||
    isMatchingUrl(req.url, pvgisApiBase) ||
    isUrlWithinBase(req.url, pvgisApiBase);

  if (token && !isPvgisRequest) {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
    };
    if (authService.isImpersonating()) {
      const impersonatorId = authService.getImpersonator()?.id;
      if (impersonatorId != null) {
        headers['X-Impersonator-User-Id'] = String(impersonatorId);
      }
    }
    req = req.clone({ setHeaders: headers });
  }

  return next(req);
};

function isMatchingUrl(requestUrl: string, targetUrl: string): boolean {
  if (!requestUrl || !targetUrl) {
    return false;
  }

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const request = new URL(requestUrl, base);
    const target = new URL(targetUrl, base);
    return request.href === target.href;
  } catch {
    return requestUrl === targetUrl || requestUrl.endsWith(targetUrl);
  }
}

function resolvePvgisApiBase(pvgisUrl: string): string {
  const url = (pvgisUrl ?? '').trim();
  if (!url) return '';
  const apiIndex = url.indexOf('/api/');
  if (apiIndex === -1) {
    return url.replace(/\/$/, '');
  }
  const afterApi = url.slice(apiIndex + 5);
  const version = afterApi.split('/')[0];
  if (!version) {
    return url.slice(0, apiIndex);
  }
  return `${url.slice(0, apiIndex)}/api/${version}`;
}

function isUrlWithinBase(requestUrl: string, baseUrl: string): boolean {
  if (!requestUrl || !baseUrl) {
    return false;
  }

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const request = new URL(requestUrl, base).href;
    const target = new URL(baseUrl, base).href.replace(/\/$/, '');
    return request.startsWith(target + '/');
  } catch {
    return requestUrl.startsWith(baseUrl.replace(/\/$/, '') + '/');
  }
}
